export const WarningSpiritColumns = [
  {title: '序号', key: 'assetId', align: 'center',},
  {title: '名称', key: 'assetName', align: 'center'},
  {title: '所属地区', key: 'companyName', align: 'center'},
  {title: '供应商名称', key: 'supplierName', align: 'center'},
  {title: '定位类型', key: 'locType', align: 'center'},
  {title: '操作', slot: 'action', width: 150, align: 'center'}
]
